import React, { useState } from 'react';
import { getUser } from '../../helpers/token';
import CommentList from './Inbox/CommentList';
import InboxTabs from './Inbox/InboxTabs';

const Inbox = ({ initialTab, increaseUnreadCountOffset }) => {
  const user = getUser();

  const [tab, setTab] = useState(initialTab);

  return (
    <>
      {user !== undefined && (
        <>
          <InboxTabs tab={tab} setTab={setTab} />
          <CommentList
            tab={tab}
            increaseUnreadCountOffset={increaseUnreadCountOffset}
          />
        </>
      )}
    </>
  );
};

export default Inbox;
